import clsx from "clsx";
import type { ReactNode } from "react";

import { Checkbox } from "./Checkbox";

type ConfirmationCheckboxProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  children: ReactNode;
  error?: string;
  disabled?: boolean;
  className?: string;
};

export function ConfirmationCheckbox({
  checked,
  onChange,
  children,
  error,
  disabled,
  className = "mt-5",
}: ConfirmationCheckboxProps) {
  return (
    <label
      className={clsx(
        "flex cursor-pointer items-start gap-3 rounded-xl border px-3 py-2 align-middle transition-colors",
        error ? "border-red-500 bg-red-50/40" : "border-theme-border bg-theme-surface",
        disabled && "cursor-not-allowed opacity-60",
        className
      )}
    >
      <Checkbox
        color="green"
        className="mt-1"
        checked={checked}
        disabled={disabled}
        onChange={(event) => onChange(event.target.checked)}
      />
      <div className="min-w-0 cursor-pointer">
        <div className="cursor-pointer text-[12px] font-medium text-theme-text">{children}</div>
        {error ? <p className="mt-1 text-[11px] font-medium text-red-600">{error}</p> : null}
      </div>
    </label>
  );
}
